const determineImageCrop = (displayType, contentType, index) => {
  const portraitOnlyDisplayTypes = ['2', '7', '11']
  if (portraitOnlyDisplayTypes.includes(displayType)) {
    return 'portrait'
  }
  if (
    (displayType === '8' && contentType === 'Video') ||
    (displayType === '12' && index > 0 && index < 4)
  ) {
    return 'widescreen'
  }
  return 'landscape'
}

export default determineImageCrop
